import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
  sx?: SxProps<Theme>;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, sx }) => (
  <div hidden={value !== index}>
    {value === index && <Box sx={sx}>{children}</Box>}
  </div>
);

export default TabPanel;
